import { FC } from 'react'
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ScoreAderenciaCard from '@/components/oportunidades/ScoreAderenciaCard'

interface AderenciaDrawerProps {
  /** Reserva cuja aderência será explicada; null = drawer fechado. */
  oportunidadeId: string | null
  empresa?: string
  onClose: () => void
}

/**
 * Drawer "Aderência" do Pipeline Comercial (Onda 5, gate C1): onde o Figma mostrava um
 * "Score comercial" derivado da etapa (7/15/22/27/30 — circular por definição), mostramos
 * a aderência calculada e explicável, decomposta componente a componente. O conteúdo é o
 * `ScoreAderenciaCard` já existente — mesma decomposição do detalhe da reserva, mesma
 * fonte (`GET /v1/oportunidades/{id}/score-aderencia`), nada recalculado aqui.
 */
export const AderenciaDrawer: FC<AderenciaDrawerProps> = ({ oportunidadeId, empresa, onClose }) => (
  <Drawer anchor="right" open={!!oportunidadeId} onClose={onClose}>
    <Box sx={{ width: { xs: 320, sm: 400 }, p: 2 }} data-testid="drawer-aderencia">
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 0.5 }}>
        <Typography variant="h6" fontWeight={700}>
          Aderência
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="Fechar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
      {empresa && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {empresa}
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
        O quanto a reserva está instruída (0–100). Cada componente nomeia o que falta para
        avançar — a soma dos componentes é o número.
      </Typography>
      {oportunidadeId && <ScoreAderenciaCard oportunidadeId={oportunidadeId} />}
    </Box>
  </Drawer>
)
